import num0Grey from '@assets/images/coin-race/race/numbers/0-grey.png';
import num0 from '@assets/images/coin-race/race/numbers/0.png';
import num1Grey from '@assets/images/coin-race/race/numbers/1-grey.png';
import num1 from '@assets/images/coin-race/race/numbers/1.png';
import num2Grey from '@assets/images/coin-race/race/numbers/2-grey.png';
import num2 from '@assets/images/coin-race/race/numbers/2.png';
import num3Grey from '@assets/images/coin-race/race/numbers/3-grey.png';
import num3 from '@assets/images/coin-race/race/numbers/3.png';
import num4Grey from '@assets/images/coin-race/race/numbers/4-grey.png';
import num4 from '@assets/images/coin-race/race/numbers/4.png';
import num5Grey from '@assets/images/coin-race/race/numbers/5-grey.png';
import num5 from '@assets/images/coin-race/race/numbers/5.png';
import num6Grey from '@assets/images/coin-race/race/numbers/6-grey.png';
import num6 from '@assets/images/coin-race/race/numbers/6.png';
import num7Grey from '@assets/images/coin-race/race/numbers/7-grey.png';
import num7 from '@assets/images/coin-race/race/numbers/7.png';
import num8Grey from '@assets/images/coin-race/race/numbers/8-grey.png';
import num8 from '@assets/images/coin-race/race/numbers/8.png';
import num9Grey from '@assets/images/coin-race/race/numbers/9-grey.png';
import num9 from '@assets/images/coin-race/race/numbers/9.png'

export const DIGITS_ARRAY = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export const NUMBER_IMAGES: Record<string, string> = {
  '0': num0,
  '1': num1,
  '2': num2,
  '3': num3,
  '4': num4,
  '5': num5,
  '6': num6,
  '7': num7,
  '8': num8,
  '9': num9,
};

export const NUMBER_IMAGES_GREY: Record<string, string> = {
  '0': num0Grey, '1': num1Grey, '2': num2Grey, '3': num3Grey, '4': num4Grey,
  '5': num5Grey, '6': num6Grey, '7': num7Grey, '8': num8Grey, '9': num9Grey,
};

export const getJackpotDigits = (amount: number): string[] => {
  const MAX_SLOTS = 7;
  const amountStr = amount ? amount.toString() : '0';
  const formattedAmount = amountStr.padStart(MAX_SLOTS, '0');
  return formattedAmount.split('').slice(-MAX_SLOTS);
};